import { first } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators, AbstractControl } from '@angular/forms';
import { ConfirmationService, MenuItem, MessageService } from 'primeng/api';
import { BankDetailService } from 'src/app/services/bank-details.service';
import { BankDetail } from '../../registration/bank-details/bankDetails';
import saveAs from 'file-saver';
import { ActivatedRoute, Router } from '@angular/router';
import { CryptoJsService } from 'src/app/services/crypto-js.service';
import { JEService } from 'src/app/services/je-services.service';
import { NULL_EXPR } from '@angular/compiler/src/output/output_ast';
import { VendorDashboardService } from 'src/app/services/vendor-dashboard.service';
import { AppLoaderService } from 'src/app/services/app-loader/app-loader.service';
import { IpAddressService } from 'src/app/services/ip-address.service';

@Component({
  selector: 'app-finance',
  templateUrl: './finance.component.html',
  styleUrls: ['./finance.component.scss'],
})
export class FinanceComponent implements OnInit {
  canEditFinanceDetails: boolean = false;
  financeCalculationsForm: FormGroup;
  isSubmitted = false;
  editIcon: string = 'pi pi-fw pi-pencil';
  saveIcon: string = 'pi pi-fw pi-check';
  showFinanceComponentDialog: boolean;
  selectedFinanceComponent: any;
  selectedRowIndex: number;
  latPosition: any;
  longPosition: any;
  MIArea: any;
  canEditMIData: boolean = false;
  editBilledData: boolean = false;
  proCalculatedData: any;
  public isProDataCalculated: boolean = false;
  public jeLogin = false;
  public sdoLogin = false;
  public xenLogin = false;
  public jeorxenLogin = false;
  public ddAssociate = false;
  public dmicada = false;
  public admin = false;
  public totalQuantityUsed: any;
  public inventoryDataForGrid: any;
  public inventoryRowFilteredData: any;
  public tableDataAfterModification: any = [];
  isSubmitEnable = false;
  userRole: any = null;
  changeActualQuantity(application, event, rowIdex) {
    // if ((Number(event.target.value) > Number(application?.BilledQuantity))) {
    //   return;
    // }
    // else {
    application.ActualQuantity = event.target.value;
    this.physicalVerficationBilledData[rowIdex] = application;
    this.physicalVerficationData.listDataForPhysicalVer =
      this.physicalVerficationBilledData;
    sessionStorage.setItem(
      'miPhysicalApplicationData',
      JSON.stringify(this.physicalVerficationData)
    );
    this.calculateTotalCostAndFarmerShare();
    // }
  }

  toggleEditFinanceDetails() {
    if (this.canEditFinanceDetails) {
      let count = 1;
      let isValid = true;
      this.physicalVerficationBilledData.forEach((data) => {
        if (
          this.greaterThan(
            Number(data.ActualQuantity),
            Number(data.BilledQuantity)
          )
        ) {
          isValid = false;
          return;
        } else {
          count++;
        }
      });
      if (isValid) {
        this.canEditFinanceDetails = !this.canEditFinanceDetails;
      } else {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail:
            'Data error! Actual Quantity cant be Greater than Billed Quantity. Invalid entry at place : ' +
            count,
        });
      }
    } else {
      this.canEditFinanceDetails = !this.canEditFinanceDetails;
    }
  }

  //Bank
  fileName = 'ExcelSheet.xlsx';
  bankAccountList: BankDetail[] = [];

  bankAccount: BankDetail;

  selectedBankAccounts: BankDetail[];

  submitted: boolean;
  items: MenuItem[];

  statuses: any[];
  cols: (
    | { field: string; header: string; customExportHeader: string }
    | { field: string; header: string; customExportHeader?: undefined }
  )[];
  exportColumns: { title: string; dataKey: string }[];
  farmerId: any;
  bankList: any;
  filteredBankList: any[];
  autoId: any;
  appId: any;
  data: any;
  physicalVerficationBilledData: any;
  physicalVerficationData: any;
  physicallyVerifiedOptions = [];
  totalCostForVerification: any;
  geolocationsarray: any = [];

  userID: any;
  ipAddress: any = '000.000.000';

  oldSsScTopUpAmount: any;
  newSsScTopUpAmount: any;
  subSsScTopUpAmount: any;

  public viewWorkFlowAllStatus: boolean = false;

  constructor(
    private _fb: FormBuilder,
    private route: ActivatedRoute,
    private router: Router,
    private cryptoJsService: CryptoJsService,
    private jeService: JEService,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private vendorService: VendorDashboardService,
    private loader: AppLoaderService,
    private ipService: IpAddressService
  ) {
    const tokenData = sessionStorage.getItem('token')
      ? JSON.parse(this.cryptoJsService.DecryptToken(sessionStorage.getItem('token')))
      : {};
    if (tokenData && (tokenData.role == 'JE' || tokenData.role == 'CJE')) {
      this.jeLogin = true;
      this.jeorxenLogin = true;
    }
    if (tokenData && (tokenData.role == 'XEN' || tokenData.role == 'CXEN')) {
      this.xenLogin = true;
      this.jeorxenLogin = true;
    }
    if (tokenData && (tokenData.role == 'SDO')) {
      this.sdoLogin = true;
      this.jeorxenLogin = false;
    }
    else if (tokenData && (tokenData.role == 'DD Associate')) {
      this.ddAssociate = true;
    }
    else if (tokenData && (tokenData.role == 'DMICADA')) {
      this.dmicada = true;
    }
    else if (tokenData && (tokenData.role == 'ADMIN')) {
      this.admin = true;
    }
  }

  ngOnInit(): void {
    const encDataD = sessionStorage.getItem('dataD') ? JSON.parse(this.cryptoJsService.DecryptSessionD(sessionStorage.getItem('dataD'))) : null;
    const loginDetails = new Map(encDataD);
    const canEditMIData = loginDetails.get('canEditMIData') ? loginDetails.get('canEditMIData') : 'No';
    const editBilledData = loginDetails.get('editBilledData') ? loginDetails.get('editBilledData') : 'No';
    const tokenInfo = loginDetails.get('tokenInfo') ? loginDetails.get('tokenInfo') : null;
    this.userRole = tokenInfo['role'] ? tokenInfo['role'] : null;

    
    this.canEditMIData = canEditMIData == 'Yes' ? true : false;
    this.editBilledData = editBilledData == 'Yes' ? true : false;

    
    this.getIP();
    this.getGPSCoordinates();
    //Physically verified options
    this.physicallyVerifiedOptions = [
      { name: 'yes', code: 'yes' },
      { name: 'no', code: 'no' },
    ];

    this.financeCalculationsForm = this._fb.group({
      physicallyVerified: ['', Validators.required],
      remarks: ['', Validators.required],
      totalEstimateAmount: ['', Validators.required],
      BoqDiscountRate: ['', Validators.required],
      transportationAmount: [0, Validators.required],
      totalBilledAmount: ['', Validators.required],
      billedTransportationAmount: ['', Validators.required],
      totalCostForPhysicalVerification: ['', Validators.required],
      totalCost: ['', Validators.required],
      maximumSubsidy: ['', Validators.required],
      farmerShare: ['', Validators.required],
      MIArea: ['', [Validators.required, Validators.min(1), (control: AbstractControl) => Validators.max(this.physicalVerficationData?.MIArea)(control)]],
      farmerInitialDeposit: ['', Validators.required],
      ChallanType: ['', Validators.required],
      SubsidyToFarmerAmount: ['', Validators.required],
      SubsidyToVendorAmount: ['', Validators.required],
      FarmerRefundAmount: ['', Validators.required],
    });

    this.route.queryParams.subscribe((params) => {
      this.autoId = this.cryptoJsService.DecryptData(params.autoId);
      this.appId = this.cryptoJsService.DecryptData(params.appId);
      this.data = { autoId: this.autoId, appId: this.appId }

      if (this.autoId) {
        if ((sessionStorage.getItem('miPhysicalAppJEGPSCoordinates') &&
          JSON.parse(sessionStorage.getItem('miPhysicalAppJEGPSCoordinates')) &&
          JSON.parse(sessionStorage.getItem('miPhysicalAppJEGPSCoordinates')).length != 0 &&
          this.jeLogin) || !this.jeorxenLogin || this.xenLogin || this.sdoLogin
        ) {
          if ((sessionStorage.getItem('jecoordinatesVerified') &&
            sessionStorage.getItem('jecoordinatesVerified') == 'true') ||
            !this.jeorxenLogin || this.xenLogin || this.sdoLogin) {
            if ((sessionStorage.getItem('miPhysicalAppXENGPSCoordinates') &&
              JSON.parse(sessionStorage.getItem('miPhysicalAppXENGPSCoordinates')) &&
              JSON.parse(sessionStorage.getItem('miPhysicalAppXENGPSCoordinates')).length != 0 && (this.xenLogin || this.sdoLogin))
              || !this.jeorxenLogin || this.jeLogin || sessionStorage.getItem('myPhysicalSurveyType') != '1') {
              if ((sessionStorage.getItem('xencoordinatesVerified') &&
                sessionStorage.getItem('xencoordinatesVerified') == 'true') ||
                !this.jeorxenLogin || this.jeLogin || sessionStorage.getItem('myPhysicalSurveyType') != '1') {
                const jegeolocationsarray = JSON.parse(sessionStorage.getItem('miPhysicalAppJEGPSCoordinates'));
                const xengeolocationsarray = JSON.parse(sessionStorage.getItem('miPhysicalAppXENGPSCoordinates'));
                const sdogeolocationsarray = JSON.parse(sessionStorage.getItem('miPhysicalAppSDOGPSCoordinates'));
                if (this.jeLogin) {
                  this.geolocationsarray = [...jegeolocationsarray];
                } else if (this.sdoLogin) {
                  if(sessionStorage.getItem('myPhysicalSurveyType') == '1'){
                    this.geolocationsarray = [...sdogeolocationsarray];
                  }else{
                    this.geolocationsarray = [];
                  }
                } else if (this.xenLogin) {
                  if(sessionStorage.getItem('myPhysicalSurveyType') == '1'){
                    this.geolocationsarray = [...xengeolocationsarray];
                  }else{
                    this.geolocationsarray = [];
                  }
                }

                if (
                  JSON.parse(
                    sessionStorage.getItem('miPhysicalApplicationData')
                  )?.AutoId == this.autoId
                ) {
                  // let val = sessionStorage.getItem('miPhysicalApplicationData');
                  // this.physicalVerficationData = JSON.parse(val);
                  // this.populateAndCalculateData(JSON.parse(sessionStorage.getItem('miPhysicalApplicationData')));

                  this.physicalVerficationData = JSON.parse(
                    sessionStorage.getItem('miPhysicalApplicationData')
                  );
                  this.populateAndCalculateData(this.physicalVerficationData);
                  if (!this.editBilledData) {
                    this.proDataCalculation();
                    // this.onFinanceCalculationFormSubmit();
                  }
                } else {
                  let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
                  let payload = atob(
                    JSON.parse(sessionToken).authToken?.split('.')[1]
                  );
                  this.loader.start();
                  this.jeService
                    .getApplicationDataForPhysicalVerification(
                      this.autoId,
                      JSON.parse(payload)?.sub
                    )
                    .pipe(first())
                    .subscribe({
                      next: (data: any) => {
                        this.loader.close();
                        this.physicalVerficationData = data;
                        sessionStorage.setItem(
                          'miPhysicalApplicationData',
                          JSON.stringify(data)
                        );
                        this.populateAndCalculateData(data);
                        if (!this.editBilledData) {
                          this.proDataCalculation();
                          // this.onFinanceCalculationFormSubmit();
                        }
                      },
                      error: () => {
                        this.loader.close();
                        this.messageService.add({
                          severity: 'error',
                          summary: 'Error Message',
                          detail:
                            'Data error! Physical Applications not loaded.',
                        });
                      },
                    });
                }
              } else {
                this.loader.close();
                this.router.navigate(
                  [this.router.url.split('/')[1], 'application'],
                  {
                    queryParams: { autoId: params.autoId, appId: params.appId },
                  }
                );
                this.messageService.add({
                  severity: 'error',
                  summary: 'Error Message',
                  detail: 'Captured GPS Coordinates are Not Matching',
                });
              }
            } else {
              this.loader.close();
              this.router.navigate(
                [this.router.url.split('/')[1], 'application'],
                { queryParams: { autoId: params.autoId, appId: params.appId } }
              );
              this.messageService.add({
                severity: 'error',
                summary: 'Error Message',
                detail: 'Please provide atleast 4 GPS Coordinates',
              });
            }
          } else {
            this.loader.close();
            this.router.navigate(
              [this.router.url.split('/')[1], 'application'],
              { queryParams: { autoId: params.autoId, appId: params.appId } }
            );
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Captured GPS Coordinates are Not Matching',
            });
          }
        }
        else {
          this.loader.close();
          this.router.navigate([this.router.url.split('/')[1], 'application'], {
            queryParams: { autoId: params.autoId, appId: params.appId },
          });
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Please provide atleast 4 GPS Coordinates',
          });
        }
      } else {
        this.loader.close();
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail: 'Data error! AutoID cant be empty',
        });
        return;
      }
    });
  }

  get financeCalculationFormControls() {
    return this.financeCalculationsForm.controls;
  }

  populateAndCalculateData(data) {
    this.physicalVerficationBilledData = data.listDataForPhysicalVer;
    //Populating the Params in Finance Calculation Form
    this.financeCalculationFormControls.totalEstimateAmount.setValue(
      data?.Estimated_Amount
    );
    this.financeCalculationFormControls.BoqDiscountRate.setValue(
      data?.BoqDiscountRate
    );
    this.financeCalculationFormControls.totalBilledAmount.setValue(
      data?.TotalBilledAmount
    );
    this.financeCalculationFormControls.billedTransportationAmount.setValue(
      data?.BilledTransportAmount
    );
    if (this.financeCalculationFormControls.MIArea.value != '' && (this.jeLogin || this.xenLogin || this.sdoLogin)) {
      // this.financeCalculationFormControls.MIArea.setValue(data?.MIArea);
    } else {
      this.financeCalculationFormControls.MIArea.setValue(data?.MIArea);
    }
    // this.financeCalculationFormControls.MIArea.setValue(data?.MIArea);
    this.financeCalculationFormControls.farmerInitialDeposit.setValue(
      data?.FarmerShare
    );
    this.financeCalculationFormControls.ChallanType.setValue(data?.ChallanType);
    this.financeCalculationFormControls.SubsidyToFarmerAmount.setValue(
      data?.SubsidyToFarmerAmount
    );
    this.financeCalculationFormControls.SubsidyToVendorAmount.setValue(
      data?.SubsidyToVendorAmount
    );
    this.financeCalculationFormControls.FarmerRefundAmount.setValue(
      data?.FarmerRefundAmount
    );
    this.calculateTotalCostAndFarmerShare();
    this.changeMiArea();
  }

  onFinanceCalculationFormGoBack() {
    if (this.userRole == 'DD Associate') {
      this.route.queryParams.subscribe((params) => {
        if (params.autoId) {
          this.router.navigate(
            [this.router.url.split('/')[1], 'application', 'image-attachment'],
            { queryParams: { autoId: params.autoId, appId: params.appId } }
          );
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! AutoID cant be Empty',
          });
        }
      });
    }
    else {
      this.route.queryParams.subscribe((params) => {
        if (params.autoId) {
          this.router.navigate(
            [this.router.url.split('/')[1], 'application', 'basic'],
            { queryParams: { autoId: params.autoId, appId: params.appId } }
          );
        } else {
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: 'Data error! AutoID cant be Empty',
          });
        }
      });
    }


  }

  editFinanceComponentDialog(component: any, rowIdex) {
    // component.inventory = component.inventory.map((val) => ({
    //   ...val,
    //   batchNumber_lotNo: val.batchNumber + '_' + val.lotNo,
    //   quantityUsed: val.QuantityUsed
    //     ? val.QuantityUsed
    //     : val.quantityUsed
    //     ? val.quantityUsed
    //     : 0,
    // }));

    this.inventoryRowFilteredData = [];
    if (component?.inventory?.length > 0) {
      component?.inventory.forEach((val) => {
        if (val?.QuantityUsed != 0) {
          this.inventoryRowFilteredData.push(val);
        }
      });
    }

    this.submitted = false;
    this.selectedRowIndex = rowIdex;
    this.selectedFinanceComponent = { ...component };
    this.totalQuantityUsed = 0;
    this.totalQuantityUsed = 0;
    this.inventoryRowFilteredData.forEach((val) => {
      this.totalQuantityUsed += val.quantityUsed;
    });

    // if(this.totalQuantityUsed > 0){
    //   this.saveFinanceComponent();
    // }

    this.showFinanceComponentDialog = true;
  }

  hideFinanceComponentDialog() {
    this.showFinanceComponentDialog = false;
  }

  saveFinanceComponent() {
    // if (this.selectedFinanceComponent?.inventory?.length > 0) {
    //   this.totalQuantityUsed = 0;
    //   this.inventoryRowFilteredData.forEach((val) => {
    //     this.totalQuantityUsed += val.quantityUsed;
    //   });

    //   let inventorySum = 0;
    //   this.selectedFinanceComponent['inventory'].forEach((val) => {
    //     inventorySum += val.quantityUsed;
    //   });

    //   if (this.totalQuantityUsed != inventorySum) {

    //     this.confirmationService.confirm({
    //       message: `Total input qunatity: ${inventorySum}.<pre>Total selected qunatity: ${this.totalQuantityUsed}.</pre> <pre>\bAre you sure you want to continue?</pre>`,
    //       accept: () => {
    //         // this.inventoryDataForGrid['inventory'].forEach((val) => {
    //         //   if (!this.inventoryRowFilteredData.includes(val)) {
    //         //     val.quantityUsed = 0;
    //         //   }
    //         // });
    //         this.submitInventoryAndCal();
    //       },
    //     });
    //     return;
    //   }
    //   else{
    //     this.submitInventoryAndCal();
    //   }
    // } else {
    this.submitted = true;
    if (this.selectedFinanceComponent.ActualQuantity < 0) {
      return;
    }
    if (
      Number(this.selectedFinanceComponent.ActualQuantity) >
      Number(this.selectedFinanceComponent.BilledQuantity)
    ) {
      return;
    } else {
      this.physicalVerficationBilledData[this.selectedRowIndex] =
        this.selectedFinanceComponent;
      this.physicalVerficationData.listDataForPhysicalVer =
        this.physicalVerficationBilledData;
      sessionStorage.setItem(
        'miPhysicalApplicationData',
        JSON.stringify(this.physicalVerficationData)
      );
      this.calculateTotalCostAndFarmerShare();
    }
    this.showFinanceComponentDialog = false;
    // }
    this.showFinanceComponentDialog = false;
  }

  submitInventoryAndCal() {
    this.inventoryDataForGrid = [this.inventoryDataForGrid].map((val) => ({
      ...val,
      filteredInventory: this.inventoryRowFilteredData,
      selectedInventory: this.inventoryRowFilteredData.map((val) => ({
        batchNumber: val?.batchNumber,
        lotNo: val?.lotNo,
        quantityUsed: val?.quantityUsed,
      })),
    }));

    let index = this.inventoryDataForGrid[0]?.id
      ? this.inventoryDataForGrid[0]?.id
      : 0;
    if (index != null) {
      this.tableDataAfterModification[index] = this.inventoryDataForGrid[0];
    }
    this.physicalVerficationBilledData.forEach((e) => {
      if (
        e.inventory.length > 0 &&
        e.SizeId == this.selectedFinanceComponent.SizeId
      ) {
        e.ActualQuantity = this.totalQuantityUsed;
        e.selectedQuantity = [...this.inventoryDataForGrid];
        e.selectedInventory = [
          ...this.inventoryDataForGrid[0].selectedInventory,
        ];
      }
    });
    this.physicalVerficationData.listDataForPhysicalVer =
      this.physicalVerficationBilledData;
    sessionStorage.setItem(
      'miPhysicalApplicationData',
      JSON.stringify(this.physicalVerficationData)
    );
    this.calculateTotalCostAndFarmerShare();

    this.showFinanceComponentDialog = false;
  }



  greaterThan(elem1, elem2) {
    return Number(elem1) > Number(elem2);
  }

  changeMiArea() {
    if (
      this.financeCalculationFormControls.MIArea.value >
      this.physicalVerficationData.MIArea
    ) {
      return;
    }
    if (
      this.physicalVerficationBilledData[0]?.ProgrammeName ==
      'Mini Sprinkler' ||
      this.physicalVerficationBilledData[0]?.ProgrammeName == 'Drip Irrigation'
    ) {
      this.financeCalculationFormControls?.transportationAmount?.setValue(
        Math.round(Number(
          this.financeCalculationFormControls.MIArea.value
            ? this.financeCalculationFormControls.MIArea.value
            : 0
        ) * 2500)
      );
    } else {
      this.financeCalculationFormControls?.transportationAmount?.setValue(0);
    }
    this.physicalVerficationData.tempMIArea = this
      .financeCalculationFormControls.MIArea.value
      ? this.financeCalculationFormControls.MIArea.value
      : 0;
    this.physicalVerficationData.BilledTransportAmount =
      this.financeCalculationFormControls?.transportationAmount?.value;
    if (this.jeLogin || this.xenLogin || this.sdoLogin) {
      this.financeCalculationsForm.controls.totalCost.setValue(
        this.financeCalculationFormControls?.transportationAmount?.value +
        this.physicalVerficationData.tempTotalCost
      );
    }

    this.totalCostForVerification = this.physicalVerficationData.tempTotalCost;
    this.financeCalculationsForm.controls.farmerShare.setValue(
      Math.ceil(Number(this.financeCalculationsForm.controls.totalCost.value * 0.15))
    );

    this.financeCalculationsForm.controls.maximumSubsidy.setValue(
      Math.round(Number(this.financeCalculationsForm.controls.totalCost.value - this.financeCalculationsForm.controls.farmerShare.value))
    );

    sessionStorage.setItem(
      'miPhysicalApplicationData',
      JSON.stringify(this.physicalVerficationData)
    );
  }

  calculateTotalCostAndFarmerShare() {
    let totalCost = 0;

    this.physicalVerficationBilledData.forEach((data) => {
      totalCost =
        totalCost +
        (data?.ActualQuantity
          ? Number(data?.ActualQuantity) * Number(data?.Price)
          : 0);
    });

    totalCost = totalCost - (totalCost * this.physicalVerficationData?.BoqDiscountRate / 100);

    this.totalCostForVerification = totalCost;
    if (
      this.financeCalculationFormControls &&
      this.financeCalculationFormControls.transportationAmount &&
      this.financeCalculationFormControls.transportationAmount.value
    ) {
      totalCost =
        this.financeCalculationFormControls?.transportationAmount?.value +
        totalCost;
    }
    this.financeCalculationsForm.controls.totalCost.setValue(totalCost);
    this.physicalVerficationData.tempTotalCost = totalCost;
    sessionStorage.setItem(
      'miPhysicalApplicationData',
      JSON.stringify(this.physicalVerficationData)
    );
    this.financeCalculationsForm.controls.farmerShare.setValue(
      Math.ceil(Number(totalCost * 0.15))
    );
    this.financeCalculationsForm.controls.maximumSubsidy.setValue(
      Math.round(Number(totalCost - this.financeCalculationsForm.controls.farmerShare.value))
    );
  }

  onFinanceCalculationFormSubmit() {
    if (this.physicalVerficationData?.listDataForPhysicalVer && this.physicalVerficationData?.listDataForPhysicalVer.length > 0) {

      if (this.jeLogin && this.physicalVerficationData?.listDataForPhysicalVer.every(val => val.ActualQuantity == 0)) {
        this.messageService.add({
          severity: 'error',
          summary: 'Error Message',
          detail:
            "Please Add Component Quantity First",
        });
        return;
      }
    }
    let components = [];
    let count = 1;
    let isValid = true;
    if (this.userRole == 'DD Associate') {
      this.isSubmitEnable = true
    }
    else {
      this.isSubmitEnable = false
    }

    this.physicalVerficationBilledData.forEach((data) => {
      if (data?.selectedInventory) {
        data.inventory = data.selectedInventory;
      }
      // else if(data?.inventory.length > 0){
      //   // data.inventory = data.selectedInventory;
      // }
      // else{
      //   data.inventory = data.selectedInventory;
      // }
      // if( !data.inventory){
      //   data.inventory=[]
      // }
      delete data.selectedInventory;
      delete data.selectedQuantity;
      if (Number(data.ActualQuantity) >= 0) {
        let body = {
          compId: data.CompId,
          catId: data.CatId,
          sizeId: data.SizeId,
          actualQuantity: data.ActualQuantity as string,
          autoIdPriceTable: data.AutoIdPriceTable,
          inventory: data.inventory
            ? data.inventory
            : data.selectedInventory
              ? data.selectedInventory
              : [],
        };
        // if(data?.inventory.length>0){
        //   body.inventory=data.inventory;
        // }
        components.push(body);
        count++;
      } else {
        isValid = false;
        return;
      }
    });

    if (this.editBilledData) {
      if (isValid) {
        this.insertPhysicalVerification(components);
      } else {
        this.confirmationService.confirm({
          message:
            'Data error! Actual Quantity cant be null. Invalid entry at place : ' +
            count,
          header: 'Confirm',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            this.insertPhysicalVerification(components);
          },
        });
      }
    } else {
      this.insertPhysicalVerification(components);
    }

  }

  proDataCalculation() {
    if (this.financeCalculationFormControls?.MIArea?.errors) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail:
          "Fill the value of 'Area Surveyed' properly",
      });
      return;
    }
    if (
      this.greaterThan(
        this.financeCalculationFormControls.MIArea.value,
        this.physicalVerficationData.MIArea
      )
    ) {
      this.messageService.add({
        severity: 'error',
        summary: 'Error Message',
        detail:
          "Actual 'Area Surveyed' cannot be greater than Billed 'Area Surveyed'",
      });
      return;
    }
    const tableDataToPush: any = [];
    let count = 1;
    let isValid = true;
    this.physicalVerficationBilledData.forEach((row) => {
      if (Number(row.ActualQuantity) > 0) {
        tableDataToPush.push({
          cat: JSON.stringify(row.CatId),
          component: row.component,
          size: row.size,
          quantity: row.ActualQuantity,
          price: row.Price,
        });
        count++;
      } else {
        tableDataToPush.push({
          cat: JSON.stringify(row.CatId),
          component: row.component,
          size: row.size,
          quantity: row.ActualQuantity,
          price: row.Price,
        });
        isValid = false;
        return;
      }
    });

    let finalDataToPost = {
      estimationComponentDetail: tableDataToPush,
      programId: this.physicalVerficationData?.ProgId,
      applicationId: this.physicalVerficationData?.AppID,
      vendorId: JSON.stringify(this.physicalVerficationData?.VendorCode),
      rowSpacing: this.physicalVerficationData?.RowSpacing,
      plantSpacing: this.physicalVerficationData?.PlantSpacing,
      // area: this.physicalVerficationData?.MIArea,
      area: this.financeCalculationFormControls.MIArea.value,
    };
    let reqBody = finalDataToPost;

    if (this.editBilledData) {
      if (isValid) {
        this.getMaxSubsidy(reqBody);
      } else {
        this.confirmationService.confirm({
          message:
            'Data error! Actual Quantity cant be null. Invalid entry at place : ' +
            count,
          header: 'Confirm',
          icon: 'pi pi-exclamation-triangle',
          accept: () => {
            this.getMaxSubsidy(reqBody);
          },
        });
      }
    } else {
      this.getMaxSubsidy(reqBody);
    }
  }
  stripText(event) {
    const seperator = '^([0-9])';
    const maskSeperator = new RegExp(seperator, 'g');
    let result = maskSeperator.test(event.key);
    return result;
  }
  getMaxSubsidy(reqBody) {
    // if (
    //   JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'))?.AppID ==
    //   JSON.parse(sessionStorage.getItem('proDataCalculation'))?.AppID
    // ) {
    //   this.proCalculatedData = JSON.parse(
    //     sessionStorage.getItem('proDataCalculation')
    //   );
    //   this.isProDataCalculated = true;
    // } else {
    this.loader.start();
    this.vendorService
      .getMaxSubsidyEstimate(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          this.proCalculatedData = data;
          this.isProDataCalculated = true;
          this.proCalculatedData.AppID = this.physicalVerficationData.AppID;
          sessionStorage.setItem('proDataCalculation', JSON.stringify(this.proCalculatedData));

          let MIdata = JSON.parse(sessionStorage.getItem('miPhysicalApplicationData'));

          // if(data?.maxSubsidy < this.financeCalculationsForm.controls.maximumSubsidy.value){
          //   let val = Math.round(this.financeCalculationsForm.controls.maximumSubsidy.value - data?.maxSubsidy) + this.financeCalculationsForm.controls.farmerShare.value;

          //   this.financeCalculationFormControls.maximumSubsidy.setValue(data?.maxSubsidy);
          //   this.financeCalculationFormControls.farmerShare.setValue(val);
          // }

          if (!(this.jeorxenLogin || this.sdoLogin)) {
            this.populateAndCalculateData(MIdata);
          }

          // let isDDAssociatePending = sessionStorage.getItem('isMIPhysicalVerPending')== 'true' ? true : false;

          if (MIdata?.BilledTransportAmount != MIdata?.EstimatedTransportAmount && (this.jeorxenLogin || (this.ddAssociate && sessionStorage.getItem('isMIPhysicalVerPending') == 'true' ? true : false))) {
            this.financeCalculationFormControls.totalCost.setValue(
              this.financeCalculationsForm.controls.totalBilledAmount.value + this.financeCalculationsForm.controls.billedTransportationAmount.value
            );
            this.calculateTotalCostAndFarmerShare();

            // if (MIdata?.ChallanType == "Farmer Share") {
            //   this.financeCalculationFormControls.SubsidyToVendorAmount.setValue(
            //     this.financeCalculationsForm.controls.maximumSubsidy.value
            //   );
            // } else {
            //   this.financeCalculationFormControls.SubsidyToFarmerAmount.setValue(
            //     this.financeCalculationsForm.controls.maximumSubsidy.value
            //   );
            // }

            if (MIdata?.ChallanType == "Full Payment") {
              this.financeCalculationFormControls.FarmerRefundAmount.setValue(0);
            } else {
              this.financeCalculationFormControls.FarmerRefundAmount.setValue(
                // MIdata.FarmerRefundAmount
                Math.round(MIdata.FarmerShare - this.financeCalculationsForm.controls.farmerShare.value)
              );
            }

            // handle -ve value condition
            if (this.financeCalculationFormControls.FarmerRefundAmount.value < 0) {
              this.financeCalculationFormControls.FarmerRefundAmount.setValue(0);
            }

            // this.financeCalculationFormControls.SubsidyToVendorAmount.setValue(
            //   this.financeCalculationsForm.controls.maximumSubsidy.value
            // );


            if (MIdata?.ApplicantType == "IsAtal" || MIdata?.ApplicantType == "7500") {
              // this.financeCalculationFormControls.FarmerRefundAmount.setValue(0);
              // this.financeCalculationFormControls.SubsidyToFarmerAmount.setValue(0);
            }

          }

          if (!(this.jeorxenLogin || this.sdoLogin)) {
            this.viewSsScTopup();
          }
        },
        error: (err) => {
          let MIdata = JSON.parse(
            sessionStorage.getItem('miPhysicalApplicationData')
          );
          if (!(this.jeorxenLogin || this.sdoLogin)) {
            this.populateAndCalculateData(MIdata);
          }

          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
        // complete: () => {
        //   this.messageService.add({
        //     severity: 'success',
        //     summary: 'Success',
        //     detail: 'Estimation Updated Successfully',
        //   });
        // },
      });
    // }
  }

  viewSsScTopup() {
    let reqBody = {
      appId: this.physicalVerficationData?.AppID,
      progId: this.physicalVerficationData?.ProgId,
      subsidyToFarmerAmount: this.financeCalculationFormControls?.SubsidyToFarmerAmount?.value,
      subsidyToVendorAmount: this.financeCalculationFormControls?.SubsidyToVendorAmount?.value,
      newSubsidyCalc: this.proCalculatedData.maxSubsidyNewCalc,
      subsidyAmt: this.proCalculatedData.maxSubsidy
    }

    this.getSsCsTopUpData(reqBody)
  }

  getSsCsTopUpData(reqBody) {
    this.loader.start();
    this.vendorService
      .getCenterStateShareCalc(reqBody)
      .pipe(first())
      .subscribe({
        next: (data) => {
          this.loader.close();
          if (data[0].result) {
            this.oldSsScTopUpAmount = null;
            this.newSsScTopUpAmount = null;
            this.subSsScTopUpAmount = null;
            this.messageService.add({
              severity: 'info',
              summary: 'Info Message',
              detail: data[0].result,
            });
          } else {
            this.oldSsScTopUpAmount = data[0][0];
            this.newSsScTopUpAmount = data[1][0];
            this.subSsScTopUpAmount = data[2][0];
          }
        },
        error: (err) => {
          this.loader.close();
          this.oldSsScTopUpAmount = null;
          this.newSsScTopUpAmount = null;
          this.subSsScTopUpAmount = null;
          this.loader.close();
          this.messageService.add({
            severity: 'error',
            summary: 'Error Message',
            detail: err,
          });
        },
      });
  }

  insertPhysicalVerification(compElements) {
    let sessionToken = this.cryptoJsService.DecryptToken(sessionStorage.getItem('token'));
    let payload = atob(JSON.parse(sessionToken).authToken?.split('.')[1]);
    let body = [];
    let element = {
      appID: this.physicalVerficationData?.AppID,
      vendorRegId: this.physicalVerficationData?.VendorCode,
      progID: this.physicalVerficationData?.ProgId,
      estimatedAmount: parseFloat(
        this.physicalVerficationData?.Estimated_Amount
      ),
      totalBilledAmount: parseFloat(
        this.physicalVerficationData?.TotalBilledAmount
      ),
      // totalCostVerification: parseFloat(this.totalCostForVerification),
      totalCostVerification: parseFloat(this.financeCalculationFormControls?.totalCost?.value),
      billedTransportAmount: parseFloat(
        this.financeCalculationFormControls?.transportationAmount?.value
      ),
      maxSubsidyAmount: parseFloat(
        this.financeCalculationFormControls?.maximumSubsidy?.value
      ),
      farmerShareAmount: parseFloat(
        this.financeCalculationFormControls?.farmerShare?.value
      ),
      subsidyToFarmer_Amount: parseFloat(
        this.financeCalculationFormControls?.SubsidyToFarmerAmount?.value
      ),
      subsidyToVendor_Amount: parseFloat(
        this.financeCalculationFormControls?.SubsidyToVendorAmount?.value
      ),
      farmerRefund_Amount: parseFloat(
        this.financeCalculationFormControls?.FarmerRefundAmount?.value
      ),
      stateShare_Amount: 0,
      centerShare_Amount: 0,
      district: this.physicalVerficationData?.District,
      block: this.physicalVerficationData?.Block,
      village: this.physicalVerficationData?.Village,
      miArea: this.physicalVerficationData?.tempMIArea,
      lat: this.physicalVerficationData?.Lat
        ? this.physicalVerficationData?.Lat
        : this.latPosition,
      long: this.physicalVerficationData?.Long
        ? this.physicalVerficationData?.Long
        : this.longPosition,
      plantSpacing: this.physicalVerficationData?.PlantSpacing,
      rowSpacing: this.physicalVerficationData?.RowSpacing,
      cropID: this.physicalVerficationData?.CropId_PV == null ? this.physicalVerficationData?.CropId : this.physicalVerficationData?.CropId_PV,
      landId: this.physicalVerficationData?.LandIds,
      userId: JSON.parse(payload)?.sub,
      remarks: this.financeCalculationFormControls?.remarks?.value,
      network_Id: this.ipAddress,
      terminal_Id: this.ipAddress,
      componentDetail: compElements,
      ProData_MaxSubsidy: this.proCalculatedData.maxSubsidy,
      // listDataForPhysicalVer:this.physicalVerficationBilledData
    };
    if (this.jeorxenLogin || this.sdoLogin) {
      element['insertSurveyGPSCoordiantes'] = this.geolocationsarray;
      element['surveyType'] = sessionStorage.getItem('myPhysicalSurveyType');
    }
    body.push(element);
    sessionStorage.setItem('miPhysicalAppReqBody', JSON.stringify(body));
    if (this.editBilledData) {
      this.messageService.add({
        severity: 'success',
        summary: 'Success Message',
        detail: 'Saved!',
      });
    }
    if (this.userRole !== 'DD Associate') {
      setTimeout(() => {
        this.route.queryParams.subscribe((params) => {
          if (params.autoId) {
            this.router.navigate(
              [this.router.url.split('/')[1], 'application', 'attachment'],
              { queryParams: { autoId: params.autoId, appId: params.appId } }
            );
          } else {
            this.messageService.add({
              severity: 'error',
              summary: 'Error Message',
              detail: 'Data error! AutoID cant be Empty',
            });
          }
        });
      }, 1000);
    }


    // this.jeService.insertPhysicalVerification(body).pipe(first())
    //   .subscribe({
    //     next: (data: any) => {
    //       this.messageService.add({ severity: 'success', summary: 'Success Message', detail: data });
    //       setTimeout(() => {
    //         this.route.queryParams
    //           .subscribe(params => {
    //             if (params.autoId) {
    //               this.router.navigate([this.router.url.split('/')[1], 'application', 'attachment'], { queryParams: { autoId: params.autoId, appId: params.appId } });
    //             } else {
    //               this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! AutoID cant be Empty' });
    //             }
    //           }
    //           );
    //       }, 1000)
    //     },
    //     error: () => {
    //       this.messageService.add({ severity: 'error', summary: 'Error Message', detail: 'Data error! Physical Verification Application not Saved.' });
    //     }
    //   });
  }



  getGPSCoordinates() {
    this._getPosition().then((pos) => {
      this.latPosition = pos.lat;
      this.longPosition = pos.lng;
    });
  }

  _getPosition(): Promise<any> {
    return new Promise((resolve, reject) => {
      navigator.geolocation.getCurrentPosition(
        (resp) => {
          resolve({ lng: resp.coords.longitude, lat: resp.coords.latitude });
        },
        (err) => {
          // reject(err);
        }
      );
    });
  }

  getIP() {
    if (sessionStorage.getItem('ipAddress')) {
      this.ipAddress = JSON.parse(window.sessionStorage.getItem('ipAddress'));
    } else {
      this.ipService.getIPAddress().subscribe((res: any) => {
        this.ipAddress = res.ip;
        sessionStorage.setItem('ipAddress', JSON.stringify(this.ipAddress));
      });
    }
  }

  onInventoryRowSelect(val) {
    this.totalQuantityUsed = 0;
    this.inventoryRowFilteredData.forEach((val) => {
      this.totalQuantityUsed += val.quantityUsed;
    });

    this.messageService.add({
      severity: 'info',
      summary: 'Row Selected',
      detail: `Total Selected Row: ${this.inventoryRowFilteredData?.length
          ? this.inventoryRowFilteredData?.length
          : 0
        }`,
    });
  }

  onInventoryRowUnselect(val) {
    this.totalQuantityUsed = 0;
    this.inventoryRowFilteredData.forEach((val) => {
      this.totalQuantityUsed += val.quantityUsed;
    });

    this.messageService.add({
      severity: 'info',
      summary: 'Row Unselected',
      detail: `Total Selected Row: ${this.inventoryRowFilteredData?.length
          ? this.inventoryRowFilteredData?.length
          : 0
        }`,
    });
  }

  onHeaderCheckboxToggle(val) {
    this.totalQuantityUsed = 0;
    this.inventoryRowFilteredData.forEach((val) => {
      this.totalQuantityUsed += val.quantityUsed;
    });

    if (val?.checked) {
      this.messageService.add({
        severity: 'info',
        summary: 'All Row Selected',
        detail: `Total Selected Row: ${this.inventoryRowFilteredData?.length
            ? this.inventoryRowFilteredData?.length
            : 0
          }`,
      });
    } else {
      this.messageService.add({
        severity: 'info',
        summary: 'All Row Unselected',
        detail: `Total Selected Row: ${this.inventoryRowFilteredData?.length
            ? this.inventoryRowFilteredData?.length
            : 0
          }`,
      });
    }
  }

  onEditComplete(val) {
    this.totalQuantityUsed = 0;
    this.inventoryRowFilteredData.forEach((val) => {
      this.totalQuantityUsed += val.quantityUsed;
    });
  }

  submitInventoryDetails() {
    this.onCloseInventoryDialog();

    this.selectedFinanceComponent = [this.inventoryDataForGrid].map((val) => ({
      ...val,
      filteredInventory: this.inventoryRowFilteredData,
      selectedInventory: this.inventoryRowFilteredData.map((val) => ({
        batchNumber: val?.batchNumber,
        lotNo: val?.lotNo,
        quantityUsed: val?.quantityUsed,
      })),
    }));

    this.totalQuantityUsed = 0;
    this.inventoryRowFilteredData.forEach((val) => {
      this.totalQuantityUsed += val.quantityUsed;
    });

    let index = this.inventoryDataForGrid[0]?.id
      ? this.inventoryDataForGrid[0]?.id
      : 0;
    if (index != null) {
      this.tableDataAfterModification[index] = this.inventoryDataForGrid[0];
    }

  }
  onCloseInventoryDialog() {
    // this.isOpenforEditing = false;
    this.showFinanceComponentDialog = false;
    // this.inventoryDataForGrid = null;
  }

  componentDetailsRowcolor(row) {
    if (row?.IsInventoryMandatory) {
      if (row?.inventory.length == 0) {
        return '#ff8080';
      } else {
        return '#f3cf8c';
      }
    } else if (row?.ActualQuantity) {
      return '#e6ffe6';
    } else {
      return '#ffffff';
    }
  }

  componentDetailsRowcolorMobile(row) {
    if (row?.IsInventoryMandatory) {
      if (row?.inventory.length == 0) {
        return '#ff8080';
      } else {
        return '#f3cf8c';
      }
    } else if (row?.ActualQuantity) {
      return '#e6ffe6';
    } else {
      return '#eaeae1';
    }
  }

  workFlowAllStatus() {
    this.viewWorkFlowAllStatus = true;
  }
}
